module.exports = __webpack_public_path__ + "images/emails/i-email-activity@2x-3ef165d6.png";